import React from 'react'
import PropTypes from 'prop-types'
import CurrentAverageCostOfLaborDetailReport from './CurrentAverageCostOfLaborDetailReport'
import DataFilters from '../../DataFilters'
import { round } from '../../../../../helpers'
import { range, find, get } from 'lodash'

export default function CurrentAverageCostOfLaborDetail(props) {

	const groups = ['E', 'M', 'P', 'S']

	const groupsNames = {
		'E': 'Executive',
		'M': 'Management',
		'P': 'Professional',
		'S': 'Support',
	}

	const onApply = (filters) => {
		props.onApply(filters, 'CurrentAverageCostOfLaborDetail')
	}

	const levelsData = []
	const groupSummary = {}
	let currentTotalN = 0

	groups.forEach(g => {
		groupSummary[g] = {
			current: { totalN: 0, totalPercent: 0, totalSalary: 0, totalActualCost: 0, totalActualPercent: 0, averageCostRows: 0 },
		}
	})

	range(14).forEach(level => {
		const levelData = props.masterData.jobGrades.filter(hd => hd.hierarchy === level)
		const groupData = {}
		groups.forEach(g => {
			groupData[g] = {
				level: '',
				title: '',
				current: { n: '', percent: '', salary: '', actualCost: 0 },
			}
		})

		levelData.forEach(ld => {
			const groupKey = ld.job_grade.slice(0, 1)
			const dataInReport = find(props.reportData, { 'compkit_job_grade': ld.job_grade })

			groupData[groupKey].level = ld.job_grade
			groupData[groupKey].title = ld.job_title

			if (dataInReport) {
				if (get(dataInReport, 'avg_annual_base_salary')) {
					groupSummary[groupKey].current.averageCostRows = groupSummary[groupKey].current.averageCostRows + 1
				}
				groupData[groupKey].current.n = get(dataInReport, 'total', 0)
				groupData[groupKey].current.salary = round(get(dataInReport, 'avg_annual_base_salary', 0) / (props.selectedCurrency !== null ? props.selectedCurrency.dollar_rate : 1))
				groupData[groupKey].current.actualCost = round(groupData[groupKey].current.salary * groupData[groupKey].current.n)
				groupSummary[groupKey].current.totalN = round(groupSummary[groupKey].current.totalN + groupData[groupKey].current.n)
				groupSummary[groupKey].current.totalSalary = round(groupSummary[groupKey].current.totalSalary + groupData[groupKey].current.salary)
				groupSummary[groupKey].current.totalActualCost = round(groupSummary[groupKey].current.totalActualCost + groupData[groupKey].current.actualCost)
			}
		})
		levelsData.push(groupData)
	})

	levelsData.forEach(level => {
		groups.forEach(group => {
			if (level[group].current.n !== '') {
				/**
				 * Below is the code for Percentage of title in group
				 * level[group].current.percent = round((level[group].current.n / groupSummary[group].current.totalN ) * 100)
				 * groupSummary[group].current.totalPercent = round(groupSummary[group].current.totalPercent + level[group].current.percent)
				*/
				level[group].current.actualPercent = round((level[group].current.actualCost / groupSummary[group].current.totalActualCost) * 100)
				groupSummary[group].current.totalActualPercent = round(groupSummary[group].current.totalActualPercent + level[group].current.actualPercent)

			}
		})
	})

	/**
	 * Below is the loop for Display logic
	 * fixing the level data to fixed to 1 decimal place
	 */
	levelsData.forEach(level => {
		groups.forEach(group => {
			if (level[group].current.n !== '') {
				
				level[group].current.actualPercent = level[group].current.actualPercent.toFixed(1)
			}
		})
	})

	Object.keys(groupSummary).forEach(key => {
		currentTotalN = round(currentTotalN + groupSummary[key].current.totalN)
		groupSummary[key].current.totalActualPercent = round(groupSummary[key].current.totalActualPercent, 0)
		groupSummary[key].current.totalSalary = round(groupSummary[key].current.totalSalary / groupSummary[key].current.averageCostRows)
	})

	return (
		<React.Fragment>
			<DataFilters
				fetchedFilterData={props.fetchedFilterData}
				filtersData={props.filtersData}
				onDataFilterSelect={props.onDataFilterSelect}
				componentName={'CurrentAverageCostOfLaborDetail'}
				reportFilters={props.reportFilters}
				resetFilter={props.resetFilter}
				onApply={onApply}
				reportFiltersType={props.reportFiltersType}
				reportDataChanged={props.reportDataChanged}
			/>
			<CurrentAverageCostOfLaborDetailReport currencyCode={props.selectedCurrency !== null ? props.selectedCurrency.short_code : 'USD'} currentTotalN={currentTotalN} groups={groups} groupSummary={groupSummary} groupsNames={groupsNames} levelsData={levelsData}></CurrentAverageCostOfLaborDetailReport>
		</React.Fragment>
	)
}

CurrentAverageCostOfLaborDetail.propTypes = {
	masterData: PropTypes.object.isRequired,
	onDataFilterSelect: PropTypes.func.isRequired,
	reportFilters: PropTypes.object.isRequired,
	reportData: PropTypes.array.isRequired,
	onApply: PropTypes.func.isRequired,
}
